import React, { useEffect, useState } from 'react';
import Moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Card, CardContent, Button, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Chart from 'react-apexcharts';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { faChartBar, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Header } from '../../layout-components';
import { Loader } from '../../shared/components/Loader';
import { KpiTile } from '../../assets/components/kpi/KpiTile';
import { MiniStatCard } from '../../assets/components/MiniStatCard/MiniStatCard';
import { MiniStatGrid } from '../../assets/components/MiniStatCard/MiniStatCard';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCountList, getMessageList, getSubmitList, getSupportMessage } from '../api';
import { Tile } from '../../assets/components/kpi/Tile';


const DashboardWrapper = styled.div`
  font-family: var(--font-family);

  .dashboardGradientCard {
    height: 100px;
  }

  .font07 {
    font-size: 13px;
    font-weight: 400;
    color: #374151;
  }

  .font09 {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }
  .font08 {
    font-size: 17px;
  }

  .dashboardCardHeight {
    height: 100% !important;
  }
  .card-box {
    border-radius: 12px;
    border: 1px solid var(--border);
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03),
    0 6px 16px rgba(0, 0, 0, 0.04);
    background: #ffffff;
  }

  .card-head {
    background-color: #fff !important;
    border-bottom: none !important;
    padding: 12px 16px;
  }

  .card-header--title {
    font-weight: 600;
    font-size: 17px;
    color: #111827;
  }

  .font-size-xxl {
    font-size: 41px;
    font-weight: 500;
  }

.noShadow {
  box-shadow: none !important;
}

.ss-progress{
  display:flex;
  flex-direction:column;
  gap: var(--s-2);
}
.ss-progress__row{
  display:flex;
  align-items:baseline;
  justify-content:space-between;
  gap: var(--s-3);
}
.ss-progress__label{
  font-size: var(--text-body);
  font-weight: var(--fw-medium);
  color: var(--muted);
}
.ss-progress__value{
  font-size: var(--text-body);
  font-weight: var(--fw-medium);
  color: var(--text);
}
.ss-progress__track{
  height: var(--progress-h);
  background: #e5e7eb;
  border-radius: 6px;
  overflow:hidden;
}
.ss-progress__fill{
  height: 100%;
  background: var(--progress-fill);
  border-radius: 6px;
  width: 0%;
}
.ss-delta{
  display:inline-flex;
  align-items:baseline;
  gap: 6px;
  font-size: var(--text-body);
  font-weight: var(--fw-medium);
}
.ss-delta--good .ss-delta__value{ color: var(--good); }
.ss-delta--bad  .ss-delta__value{ color: var(--bad); }
.ss-delta__label{ color: #1f2937; font-weight: 500; }

/* Bottom Tables Section Styles */
.dashboard-table-card {
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  background: #ffffff;
}

.dashboard-table-card .card-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.dashboard-table-card .card-header--title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.dashboard-table-card .view-all-link {
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 2px;
  transition: color 0.2s;
}

.dashboard-table-card .view-all-link:hover {
  color: #111827;
}

.dashboard-tabs {
  display: flex;
  gap: 6px;
}

.dashboard-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: transparent;
  color: #6b7280;
  border: 1px solid transparent;
}

.dashboard-tab:hover {
  background-color: #f3f4f6;
}

.dashboard-tab.active {
  background-color: #f3f4f6;
  color: #111827;
  border-color: #e5e7eb;
}

.dashboard-tab .tab-count {
  background-color: #e5e7eb;
  color: #374151;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 9px;
  font-weight: 600;
}

.dashboard-table {
  width: 100%;
  border-collapse: collapse;
}

.dashboard-table thead th {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #1f2937;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.dashboard-table tbody tr {
  transition: background-color 0.15s;
}

.dashboard-table tbody tr:hover {
  background-color: #f9fafb;
}

.dashboard-table tbody td {
  font-size: 11px;
  font-weight: 600;
  color: #111827;
  padding: 8px 12px;
  border-bottom: 1px solid #f5f5f5;
}

.dashboard-table tbody tr:last-child td {
  border-bottom: none;
}

/* Phase 1: Dashboard KPI Tile Overrides */
.dashboard-kpi-grid {
  .ss-tile {
    padding: 16px 20px;
  }
  .ss-kpi__label {
    font-size: 13px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 8px;
  }
  .ss-kpi__value {
    font-size: 38px;
    font-weight: 700;
    color: #111827;
  }
  .ss-trend {
    margin-left: 8px;
  }
  .ss-trend__value {
    font-size: 16px;
    font-weight: 500;
  }
  .ss-trend__label {
    font-size: 16px;
    color: #1f2937;
    font-weight: 500;
  }
  .ss-trend--good .ss-trend__value {
    color: #059669;
  }
  .ss-trend--bad .ss-trend__value {
    color: #dc2626;
  }
}

`;

export default function Dashboard() {

  var [dashboardCount, setDashboardCount] = React.useState({});
  var [totalCount, setTotalCount] = React.useState(0);
  var [lastSubmits, setLastSubmits] = useState([]);
  var [message, setMessage] = React.useState([]);
  var [allMessages, setAllMessages] = React.useState([]);
  var [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  var [userEmail, setUserEmail] = React.useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  var [userProfile, setUserProfile] = React.useState();
  var [range, setRange] = React.useState("MONTH");
  var [activeTab, setActiveTab] = React.useState("UNREAD");
  const unreadCount = allMessages.filter(m => m.isRead === false).length;
  const openCount = allMessages.filter(m => m.isRead === true).length;
  const errorMessage = () => toast("An error occured, try again later!");

  const ProgressBar = ({ label, value, color }) => {
    const visualMax = 20;
    const percent = Math.min((value / visualMax) * 100, 100);

    return (
      <div className="row align-items-center mb-2 g-0">
        <div className="col-4" style={{ lineHeight: "1.5", fontSize: "16px", fontWeight: 600, color: "#1b1f24" }}>{label}</div>
        <div className="col-7">
          <div className="progress" style={{ height: "22px", borderRadius: "5px" }}>
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${percent}%`,
                backgroundColor: color,
                borderRadius: "5px",
              }}
            />
          </div>
        </div>
        <div className="col-1 text-end" style={{ fontWeight: 500, fontSize: "16px" }}>{value}</div>
      </div>
    );
  };

  const TodaysActionProgressBar = () => {
    const visualMax = 50;
    const data = [
      { label: "Sent", value: dashboardCount.todayScheduled, color: "#7ea6c7" },
      { label: "Completed", value: dashboardCount.todayCompleted, color: "#78b7a5" }
    ];

    return (
      <>
        {data.map((item, index) => {
          const percent = (item.value / visualMax) * 100;

          return (
            <div className="row align-items-center mb-2 g-0" key={index}>
              <div className="col-6" style={{ fontSize: "16px", fontWeight: 600, color: "#1f2937" }}>
                {item.label}
              </div>

              <div className="col-6">
                <div
                  className="progress position-relative"
                  style={{
                    height: "22px",
                    borderRadius: "5px",
                    backgroundColor: "#eaeaea",
                    overflow: "hidden"
                  }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${percent / 50 * 100}%`,
                      backgroundColor: item.color,
                      borderRadius: "5px"
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#111827",
                      zIndex: 2
                    }}
                  >
                    {item.value}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const seriesColors = ["#4c72b0", "#55a868", "#64b5cd", "#8c8c8c", "#b26680", "#8172b3", "#da8bc3", "#c44e52", "#dd8452", "#ccb974", "#669966", "#937860"];

  const seriesLabel = Object.keys(dashboardCount.categoryList || {});
  const ydtLabel = Object.keys(dashboardCount.yearlyCategoryList || {});

  const series = Object.values(dashboardCount.categoryList || {});
  const ydtseries = Object.values(dashboardCount.yearlyCategoryList || {});

  const weekData = seriesLabel.map((label, index) => ({
    label,
    value: series[index],
    color: seriesColors[index % seriesColors.length]
  }));

  const ytdData = ydtLabel.map((label, index) => ({
    label,
    value: ydtseries[index],
    color: seriesColors[index % seriesColors.length]
  }));

  useEffect(() => {
    userProfile = localStorage.getItem("userProfile");
    userProfile = JSON.parse(userProfile);
    setUserProfile(userProfile);
    userEmail = userProfile.userEmail;
    setUserEmail(userEmail);

    fetchCountList(range);
    fetchMessageList(range);
    fetchSubmitList(range);
    
  }, []);

  const fetchCountList = async (range) => {
    setLoading(true);
    try {
      const res = await getCountList(range);
      if (res.data.successCode === 0) {
        dashboardCount = res.data.data;
        setDashboardCount(dashboardCount);
        if (dashboardCount !== undefined) {
          totalCount = (dashboardCount.pfCount + dashboardCount.uiCount + dashboardCount.exceptionCount);
          setTotalCount(totalCount)
        }
      } else {
        errorMessage();
      }
    } catch (error) {
      errorMessage();
    } finally {
      setLoading(false);
    }
  }

  const fetchMessageList = async (range) => {
    try {
      const res = await getMessageList(range);
      if (res.data.successCode === 0) {
        message = res.data.data
        setMessage(message);
        allMessages = res.data.data
        setAllMessages(allMessages);
      } else {
        errorMessage();
      }
    } catch (error) {
      errorMessage();
    }
  }

  const fetchSubmitList = async (range) => {
    try {
      const res = await getSubmitList(range);
      if (res.data.successCode === 0) {
        lastSubmits = res.data.data
        setLastSubmits(lastSubmits);
      } else {
        errorMessage();
      }
    } catch (error) {
      errorMessage();
    }
  }

  const handleRangeChange = (selectedRange) => {
    setRange(selectedRange);
    fetchCountList(selectedRange);
    fetchMessageList(selectedRange);
    fetchSubmitList(selectedRange);
  }

  const filterMessage = (type) => {
    let filteredMessage = allMessages;

    if (type === "UNREAD") {
      filteredMessage = allMessages.filter(m => m.isRead === false)
    }

    if (type === "OPEN") {
      filteredMessage = allMessages.filter(m => m.isRead === true)
    }
    setMessage(filteredMessage);
  }

  const MessageData = {
    header: ['Subject', 'Issue Type', 'Sender', 'Created Date']
  }

  const LastSubmitData = {
    header: ['Client Name', 'Site', 'Area', 'Inspection Date', 'Submitted By']
  }

  return (
    <DashboardWrapper>
      <ToastContainer theme="dark" progressStyle={{ backgroundColor: "#F59300" }} />
      <Header onRangeChange={handleRangeChange} />

      {loading ? (
        <div className="d-flex align-items-center vh-100 justify-content-center text-center font-weight-bold font-size-lg py-3">
          <Loader color="#ff9900" />
        </div>
      ) :
        <>
          <Grid container spacing={2} className="mb-4 dashboard-kpi-grid">
            <Grid item xs={12} sm={6} md={3}>
              <KpiTile label="Safety Sheets Completed" value={dashboardCount.sheetsCompleted} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <KpiTile label="Average Safety Score" value={dashboardCount.averageScore} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <KpiTile label="Safety Observations" value={dashboardCount.totalObservation} trendValue={dashboardCount.totalObservationLastMonth < 0 ? `${dashboardCount.totalObservationLastMonth}%` : `+${dashboardCount.totalObservationLastMonth}%`} trendLabel="vs last month" trendTone={dashboardCount.totalObservationLastMonth < 0 ? "bad" : "good"} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <KpiTile label="Incidents" value={dashboardCount.totalIncidents} trendValue={dashboardCount.totalIncidentsLastMonth < 0 ? `${dashboardCount.totalIncidentsLastMonth}` : `+${dashboardCount.totalIncidentsLastMonth}`} trendLabel="last month" trendTone={dashboardCount.totalIncidentsLastMonth < 0 ? "good" : "bad"} />
            </Grid>
          </Grid>

          <Grid container spacing={1} alignItems="flex-start">
            <Grid item xs={12} sm={12} md={7}>
              <Grid item xs={12} sm={12} md={12}>
                <Card className="card-box dashboardCardHeight mb-2">
                  <div className="card-header pr-2 d-block">
                    <div className="card-header--title">Safety Observations Breakdown</div>
                  </div>
                  <CardContent className="p-3" style={{ height: "280px" }}>
                    {weekData.length === 0 ? (
                      <div className="d-flex justify-content-center align-items-center text-muted" style={{ height: "270px", overflow: "hidden" }}>
                        No data available at this moment
                      </div>
                    ) : (weekData.sort((a, b) => b.value - a.value).slice(0, 8).map((item, index) => (
                      <ProgressBar
                        key={index}
                        label={item.label}
                        value={item.value}
                        color={item.color}
                      />
                    )))}
                  </CardContent>
                </Card>
              </Grid>

              <Grid container spacing={0.5}>
                <Grid item xs={12} sm={4} md={4}>
                  <Card className="card-box mb-4" sx={{ height: "90%" }}>
                    <div className="card-head pr-2 pb-0">
                      <div className="card-header--title p-1" style={{ borderBottom: "1px solid #e0e0d1" }}>Today's Action</div>
                    </div>
                    <CardContent className="p-3">
                      <TodaysActionProgressBar />
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <Card className="card-box" sx={{ height: "90%" }}>
                    <div className="card-head px-2 pb-0">
                      <div className="card-header--title p-1" style={{ borderBottom: "1px solid #e0e0d1" }}>Site Safety Coverage</div>
                    </div>

                    <div className="card-head px-3">
                      <div className="font-size-sm"><b className="font-size-xl" style={{ color: "#111827" }}>{dashboardCount.sitesCovered}</b> <span style={{ color: "#1f2937", fontWeight: 500 }}>of</span> <b className="font-size-xl" style={{ color: "#111827" }}>{dashboardCount.activeSites}</b> <span style={{ color: "#1f2937", fontWeight: 500 }}>sites covered</span></div>
                      <div style={{ color: "#111827", fontWeight: 600 }}>{Math.round((dashboardCount.sitesCovered / dashboardCount.activeSites) * 100)}%</div>
                    </div>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <Card className="card-box" sx={{ height: "90%" }}>
                    <div className="card-head pr-2 pb-0">
                      <div className="card-header--title p-1" style={{ borderBottom: "1px solid #e0e0d1" }}>Certificate Summary</div>
                    </div>

                    <div className="px-4 py-2 d-flex justify-content-around">
                      <div className="text-center">
                        <div className="font-size-xl" style={{ fontWeight: 700, color: "#111827" }}>{dashboardCount.validCerts}</div>
                        <div style={{ color: "#1f2937", fontWeight: 600, fontSize: "16px" }}>Valid</div>
                      </div>

                      <div className="text-center">
                        <div className="font-size-xl" style={{ fontWeight: 700, color: "#111827" }}>{dashboardCount.expiredCerts}</div>
                        <div style={{ color: "#1f2937", fontWeight: 600, fontSize: "16px" }}>Expired</div>
                      </div>
                    </div>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={5}>
              <Tile title="Operational Snapshot" className="mb-3">
                <MiniStatGrid>
                  <MiniStatCard value={dashboardCount.activeClients} title="Active Clients" />
                  <MiniStatCard value={dashboardCount.activeSites} title="Active Sites" />
                  <MiniStatCard value={dashboardCount.expiringCerts} title="Certificates Expiring" subtitle="30 days" tone="warn" />
                  <MiniStatCard value={dashboardCount.unreadIssues} title="Support Inbox" subtitle="Unread/Open" />
                </MiniStatGrid>
              </Tile>

              <Tile title="Monthly Sheets Completed" className="mb-4 pb-4">
                <hr style={{ margin: "8px 0" }} />
                <div>
                  <div className="fs-6 text pb-2"><b className="fs-4 text">{dashboardCount.monthlySheet} &nbsp;</b><span style={{ color: "#1b1f24" }}>Sheets Completed</span></div>
                  <div style={{
                    height: "14px",
                    backgroundColor: "#e6e6e6",
                    borderRadius: "4px",
                    overflow: "hidden",
                    marginBottom: "4px"
                  }}>
                    <div style={{
                      width: `${Math.min((dashboardCount.monthlySheet / 500) * 100, 100)}%`,
                      height: "100%",
                      backgroundColor: "#7fa89a",
                      borderRadius: "4px"
                    }} />
                  </div>
                  <div>
                    <span className="d-block pt-1" style={{ color: "#1f2937", fontWeight: 500, fontSize: "16px" }}>Month to date</span>
                  </div>

                  <div className={`ss-delta ${dashboardCount.monthlySheetLastMonth < 0 ? "ss-delta--bad" : "ss-delta--good"}`} style={{ marginTop: "8px", marginBottom: "0" }}>
                    <span className="ss-delta__value">
                      {dashboardCount.monthlySheetLastMonth < 0 ? "" : "+"}
                      {dashboardCount.monthlySheetLastMonth}%
                    </span>
                    <span className="ss-delta__label">vs last month</span>
                  </div>
                </div>
              </Tile>
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={12} sm={12} md={6}>
              <Card className="dashboard-table-card mb-4" sx={{ height: "100%" }}>
                <div className="card-header d-flex align-items-center pb-2">
                  <div className="card-header--title">Support Messages</div>
                  <div className="dashboard-tabs ms-4">
                    {[
                      { label: "Unread", count: unreadCount, type: "UNREAD" },
                      { label: "Open", count: openCount, type: "OPEN" },
                      { label: "All", type: "ALL" }
                    ].map((item, index) => (
                      <div
                        key={index}
                        className={`dashboard-tab ${activeTab === item.type ? 'active' : ''}`}
                        onClick={() => {
                          setActiveTab(item.type);
                          item.type === "ALL" ? setMessage(allMessages) : filterMessage(item.type);
                        }}
                      >
                        {item.label}
                        {item.count !== undefined && (
                          <span className="tab-count">{item.count}</span>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="view-all-link ms-auto" onClick={() => navigate('/support/messages/list')}>
                    View All
                    <KeyboardArrowRightIcon style={{ fontSize: 18 }} />
                  </div>
                </div>

                <CardContent className="p-0">
                  <table className="dashboard-table">
                    <thead>
                      <tr>
                        {MessageData.header.map((headerItem, index) => (
                          <th key={index}>{headerItem}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {message.slice(0, 10).map((msg, index) => (
                        <tr key={index}>
                          <td>{msg.subject}</td>
                          <td>{msg.issueType}</td>
                          <td>{msg.userName}</td>
                          <td>{Moment(Date.parse(msg.createdDate)).format('MM/DD/YYYY h:mm A')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <Card className="dashboard-table-card mb-4" sx={{ height: "100%" }}>
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="card-header--title">Safety Sheets</div>
                  <div className="view-all-link" onClick={() => navigate('/formsubmission/list')}>
                    View All
                    <KeyboardArrowRightIcon style={{ fontSize: 18 }} />
                  </div>
                </div>
                <CardContent className="p-0">
                  <table className="dashboard-table">
                    <thead>
                      <tr>
                        {LastSubmitData.header.map((headerItem, index) => (
                          <th key={index}>{headerItem}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {lastSubmits.slice(0, 10).map((submit, index) => (
                        <tr key={submit.id || index}>
                          <td>{submit.client}</td>
                          <td>{submit.siteName}</td>
                          <td>{submit.areaName}</td>
                          <td>{Moment(Date.parse(submit.inspectionDate)).format('MM/DD/YYYY h:mm A')}</td>
                          <td>{submit.submittedBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </>
      }

    </DashboardWrapper>
  );
}
